import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

interface CategoryDropdownProps {
  scrolled?: boolean;
}

export default function CategoryDropdown({ scrolled = false }: CategoryDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const buttonClasses = scrolled
    ? 'bg-background-100 text-foreground-800 hover:bg-background-200'
    : 'bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm';

  return (
    <div ref={dropdownRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${buttonClasses}`}
        aria-expanded={isOpen}
      >
        <span>Browse Categories</span>
        {isOpen ? (
          <i className="ri-arrow-up-s-line text-base transition-transform duration-200"></i>
        ) : (
          <i className="ri-arrow-down-s-line text-base transition-transform duration-200"></i>
        )}
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-72 bg-white rounded-lg border border-background-200 overflow-hidden z-50">
          <div className="max-h-[420px] overflow-y-auto py-2">
            {categories.map((cat) => (
              <a
                key={cat.slug}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-between px-4 py-2.5 text-sm text-foreground-800 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                onClick={() => setIsOpen(false)}
              >
                <span className="whitespace-nowrap">{cat.name}</span>
                <i className="ri-arrow-right-up-line text-foreground-400 text-xs ml-3"></i>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}